// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { createApp, configureCompat } from 'vue'
import App from './App.vue'
import router from './router'
import store from './plugins/store'
import Util from './common/util';

import { Amplify } from 'aws-amplify'
import 'maplibre-gl/dist/maplibre-gl.css'

// Bootstrap Vue Next - 個別コンポーネントをインポート
import bootstrapVuePlugin from './plugins/bootstrap-vue.js'
import './assets/css/custom.css'

import "./assets/scss/global.scss"
import "./style.css"

// Vue 3互換モードを設定
configureCompat({
  MODE: 2,
  COMPONENT_V_MODEL: false,  // Vue 3のv-modelを使用
  COMPONENT_FUNCTIONAL: false, // Vue 3のfunctional componentを使用
  COMPONENT_ASYNC: false, // 非同期コンポーネントの互換警告を無効化
  WATCH_ARRAY: false, // 配列watchは適切にdeep:trueを設定済みのため無効化
  INSTANCE_ATTRS_CLASS_STYLE: false, // Bootstrap Vue Next内部のinheritAttrs警告を無効化
  ATTR_FALSE_VALUE: false, // false-value属性の処理方法変更警告を無効化
  OPTIONS_BEFORE_DESTROY: false, // beforeDestroy → beforeUnmount 名前変更警告を無効化
})

// Amplify v5.3.12設定（環境変数から）
// テスト用にダミー設定を使用
Amplify.configure({
  Auth: {
    region: 'ap-northeast-1',
    userPoolId: import.meta.env.VITE_COGNITO_USERPOOLID || 'dummy-pool-id',
    userPoolWebClientId: import.meta.env.VITE_COGNITO_USERPOOLWEBCLIENTID || 'dummy-client-id',
    identityPoolId: import.meta.env.VITE_COGNITO_IDENTITYPOOLID || 'dummy-identity-pool-id',
  }
})

let languageDict = {
  ja:{
      'Sign In Account' : 'アカウントにサインイン',
      'User Name' : 'ユーザ名',
      'Enter your User Name' : 'ユーザ名を入力してください',
      'Password' : 'パスワード',
      'Enter your password' : 'パスワードを入力してください',
      'Forgot your password? ' : ' ',
      'Reset password' : ' ',
      'No account?' : 'まだアカウントがない場合',
      'Back to Sign In' : 'サインイン画面に戻る',
      'Send Code' : '確認コードを送信',
      'Create account' : 'アカウント作成',
      'Sign In' : 'サインイン',
      'Sign Out' : 'サインアウト',
      'Username cannot be empty' : 'ユーザー名が入力されていません',
      'Incorrect username or password.' : 'ユーザー名もしくはパスワードが間違っています',
      'Custom auth lambda trigger is not configured for the user pool.' : 'パスワードが入力されていません',
      "2 validation errors detected: Value at 'userAlias' failed to satisfy constraint: Member must satisfy regular expression pattern: [\\p{L}\\p{M}\\p{S}\\p{N}\\p{P}]+; Value at 'userName' failed to satisfy constraint: Member must satisfy regular expression pattern: [\\p{L}\\p{M}\\p{S}\\p{N}\\p{P}]+" : "ユーザー名もしくはパスワードが間違っています",
      "Password attempts exceeded":"サインイン失敗上限回数を超えました。\r\n \
                                    しばらく経ってからサインインしてください。\r\n \
                                    サインインが出来ない場合は、\r\n \
                                    カスタマーサポートへお問い合わせください。"
  }
}

/* eslint-disable no-new */
const app = createApp(App)

// BootstrapVue3を個別コンポーネントプラグインとして使用
app.use(bootstrapVuePlugin)

app.mixin(Util)
app.use(router)
app.use(store)

app.mount('#app')
